import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import messages from './TechnicalError.messages';

const TechnicalError = () => {
    const intl = useIntl();

    return (
        <>
            <div className="title-text">
                <FormattedMessage {...messages.title} />
            </div>
            <div className="content-text" data-testid="error-details-text">
                <FormattedMessage
                    {...messages.message}
                    values={{
                        phoneLink: (
                            <a
                                href={`tel:${intl
                                    .formatMessage(messages.phoneNumber)
                                    .replaceAll(' ', '')
                                    .replaceAll('/', '')}`}>
                                <FormattedMessage {...messages.phoneNumber} />
                            </a>
                        )
                    }}></FormattedMessage>
            </div>
        </>
    );
};

export default TechnicalError;
